import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { DatePicker } from 'rsuite';
import moment from 'moment';
import { labelSizeClass } from './labelSize';

const STYLE_ID = 'ui-input-date-overrides';

const css = `
.rs-picker-date > .rs-input-group.rs-input-group-inside {
    border-radius: 0 !important;
    border: 1px solid #dee2e6 !important;
    box-shadow: none !important;
    padding: 0 !important;
    height: auto !important;
    min-height: 0 !important;
}
.rs-picker-date > .rs-input-group.rs-input-group-inside:focus-within {
    border-color: #86b7fe !important;
    box-shadow: none !important;
    outline: none !important;
}
.rs-picker-date .rs-input-group.rs-input-group-inside .rs-input {
    font-size: 12px !important;
    font-family: inherit !important;
    padding: 5px 8px !important;
    border-radius: 0 !important;
    border: none !important;
    height: auto !important;
    min-height: 0 !important;
    line-height: 1.5 !important;
    box-shadow: none !important;
    outline: none !important;
    color: #212529 !important;
    background: #fff !important;
}
.rs-input-group.rs-input-group-inside .rs-input-group-addon {
    padding: 0 6px !important;
    border: none !important;
    border-radius: 0 !important;
    height: auto !important;
    min-height: 0 !important;
    display: flex !important;
    align-items: center !important;
    background: transparent !important;
    font-size: 12px !important;
}
`;

function UiInputDate({ label, name, size, labelSize, asTable, dateFormat, ...rest }: any) {
    const { register, setValue, watch } = useFormContext();
    let value = watch(name);

    if (value && !(value instanceof Date)) {
        const parsed = moment(value);
        value = parsed.isValid() ? parsed.toDate() : null;
    }

    useEffect(() => {
        register(name);
    }, [register]);

    useEffect(() => {
        if (!document.getElementById(STYLE_ID)) {
            const style = document.createElement('style');
            style.id = STYLE_ID;
            style.textContent = css;
            document.head.appendChild(style);
        }
    }, []);

    return (
        <div className={`col-lg-${size || 12}`}>
            <div className={`form-item${labelSizeClass(labelSize)}`}>
                {!asTable && <label className="form-label">{label}</label>}
                <div className="field-container">
                    <DatePicker
                        format="dd/MM/yyyy"
                        value={value || null}
                        onChange={(date) => setValue(name, date ? moment(date).format('YYYY-MM-DD') : null)}
                        container={() => document.body}
                        placement="autoVerticalStart"
                        oneTap
                        block
                        {...rest}
                    />
                </div>
            </div>
        </div>
    );
}

export default React.memo(UiInputDate);
